import { render } from "solid-js/web";
import "@fastdiff/ui/theme.css";
import App from "./App";

const root = document.getElementById("root");
if (!root) {
  throw new Error("#root not found");
}
render(() => <App />, root);
